module.exports = __webpack_public_path__ + "contacts-cbf4f629/upsell_icon_purple-357c0df2daa637a1406e5b9e86d970f8.png";